export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9081.2af85314.jpg";